import * as dataRoomStore from './store'

export function dataRoomModule({ store }) {
  store.registerModule('data-room', { ...dataRoomStore, namespaced: true })
}
